import { render, staticRenderFns } from "./productsFeatures.vue?vue&type=template&id=52540dfa&"
import script from "./productsFeatures.vue?vue&type=script&lang=js&"
export * from "./productsFeatures.vue?vue&type=script&lang=js&"
import style0 from "./productsFeatures.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports